import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached alerts data
export function useAlertsSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/alerts"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
